import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { constant } from 'app/modules/common/helpers/constant';
import API from '../../common/services/api.config.json';
import { ApiService } from '../../../modules/common/services/api.service';

@Injectable()
export class SidebarTreeService {

     constructor(private http: HttpClient, private apiService: ApiService) { }
     getTreeViewData(_treeParams) {
          let url = `${API.Calendar.getTreeViewData}`
          url = url.replace('{paramArray}', _treeParams.paramArray);
          return this.apiService.get(url);
     }
}
